const VerifiedModal = ({ filters, setFilters, onClose }) => {
  const selected = filters.verified === true;

  const toggleVerified = () => {
    setFilters({
      ...filters,
      verified: selected ? null : true,
    });
    onClose();
  };

  return (
    <div className="w-full relative">
            {/* Arrow Pointer */}
      <div className="absolute -top-5 left-10 w-4 h-4 bg-white rotate-45 border-l border-t"></div>
      <h2 className="text-lg font-semibold mb-4">Verified</h2>

      <button
        type="button"
        onClick={toggleVerified}
        className={`w-full text-left px-4 py-2 rounded-lg mb-1 transition ${
          selected ? "bg-black text-white" : "hover:bg-gray-100"
        }`}
      >
        Verified influencers only
      </button>

      <button
        type="button"
        onClick={() => {
          setFilters({ ...filters, verified: null });
          onClose();
        }}
        className="w-full text-right text-sm text-orange-500 hover:underline mt-1 mr-4"
      >
        Clear
      </button>
    </div>
  );
};

export default VerifiedModal;
